<template>
  <a-card :title="$t('复核记录详情')" style="margin: 8px">
    <!-- <a-button slot="extra" type="primary" style="margin-right: 8px" ghost v-print="'#printContent'">
      <a-icon type="printer" />{{ $t("打印") }}</a-button
    > -->
    <a-button
      slot="extra"
      type="primary"
      ghost
      @click="
        () => {
          this.$router.go(-1);
        }
      "
    >
      <a-icon type="left" />{{ $t("返回") }}</a-button
    >
    <section id="printContent">
      <a-spin :spinning="spinning">
        <a-descriptions bordered>
          <a-descriptions-item :label="$t('出库通知单号')">
            {{ detailInfo.delivery_order_number }}
          </a-descriptions-item>
          <a-descriptions-item :label="$t('订单类型')">
            {{ detailInfo.order_type_name }}
          </a-descriptions-item>
          <a-descriptions-item :label="$t('物流单号')">
            {{ detailInfo.logistics_number }}
          </a-descriptions-item>
          <a-descriptions-item :label="$t('货主')">
            {{ detailInfo.client_name }}
          </a-descriptions-item>
          <a-descriptions-item :label="$t('仓库')">
            {{ detailInfo.warehouse_name }}
          </a-descriptions-item>
          <a-descriptions-item :label="$t('仓库编号')">
            {{ detailInfo.warehouse_number }}
          </a-descriptions-item>
          <a-descriptions-item :label="$t('往来单位单号')">
            {{ detailInfo.external_number }}
          </a-descriptions-item>
          <a-descriptions-item :label="$t('收货地址')">
            {{ detailInfo.receiving_address }}
          </a-descriptions-item>
          <a-descriptions-item :label="$t('创建人')">
            {{ detailInfo.creator_name }}
          </a-descriptions-item>
          <a-descriptions-item :label="$t('创建时间')">
            {{ detailInfo.create_time }}
          </a-descriptions-item>
          <a-descriptions-item :label="$t('托盘数量')">
            {{ detailInfo.pallet_quantity }}
          </a-descriptions-item>
          <a-descriptions-item :label="$t('备注')">
            {{ detailInfo.remark }}
          </a-descriptions-item>
        </a-descriptions>
      </a-spin>

      <div style="margin-top: 16px">
        <a-table
          rowKey="id"
          size="small"
          :columns="curColumns"
          :data-source="materialItems"
          :loading="materialLoading"
          :pagination="false"
          :scroll="{ x: 2000 }"
        >
        </a-table>
      </div>
    </section>
  </a-card>
</template>

<script>
import { deliveryRecordDetail, deliveryRecordMaterials } from "@/api/stockOut";

export default {
  name: "DeliveryRecordDetail",
  components: {},
  data() {
    return {
      description: this.$t("详情"),
      spinning: false,
      materialLoading: false,
      visible: false,
      detailInfo: {},
      materialItems: [],
      columns: [
        {
          title: this.$t("序号"),
          dataIndex: "index",
          key: "index",
          width: 60,
          customRender: (value, item, index) => {
            return index + 1;
          },
        },
        {
          title: this.$t("货品编号"),
          dataIndex: "material_number",
          key: "material_number",
        },
        {
          title: this.$t("货品名称"),
          dataIndex: "material_name",
          key: "material_name",
        },
        {
          title: this.$t("复核数量"),
          dataIndex: "total_quantity",
          key: "total_quantity",
        },
        {
          title: this.$t("复核重量(吨)"),
          dataIndex: "total_weight",
          key: "total_weight",
        },
        {
          title: this.$t("复核面积(平方米)"),
          dataIndex: "total_area",
          key: "total_area",
        },
        {
          title: this.$t("复核体积(立方米)"),
          dataIndex: "total_volume",
          key: "total_volume",
        },
        {
          title: this.$t("单位"),
          dataIndex: "unit",
          key: "unit",
        },
        {
          title: this.$t("运输计费单位"),
          dataIndex: "transport_charge_unit_display",
          module: "finance",
        },
        {
          title: this.$t("运输单价"),
          dataIndex: "transport_unit_price",
          module: "finance",
        },
        {
          title: this.$t("运输费用"),
          dataIndex: "transport_amount",
          module: "finance",
        },
        {
          title: this.$t("装卸计费单位"),
          dataIndex: "handling_charge_unit_display",
          module: "finance",
        },
        {
          title: this.$t("装卸单价"),
          dataIndex: "handling_unit_price",
          module: "finance",
        },
        {
          title: this.$t("装卸费用"),
          dataIndex: "handling_amount",
          module: "finance",
        },
        {
          title: this.$t("序列号"),
          dataIndex: "serial_number",
          key: "serial_number",
        },
        {
          title: this.$t("箱号"),
          dataIndex: "packing_number",
        },
      ],
    };
  },
  computed: {
    enableCharge() {
      return this.$store.state.user.enableCharge;
    },
    curColumns() {
      const items = [];
      for (const item of this.columns) {
        if (!this.enableCharge && item.key === "charge_value") {
          continue;
        }

        if (!this.enableCharge && item.key === "charge_unit") {
          continue;
        }

        if (!this.enableCharge && item.module === "finance") {
          continue;
        }

        items.push(item);
      }
      return items;
    },
  },
  methods: {
    initData() {
      this.getData(this.$route.query.id);
    },
    getData(id) {
      this.spinning = true;
      this.materialLoading = true;
      deliveryRecordDetail({ id })
        .then((data) => {
          this.detailInfo = data;
        })
        .finally(() => {
          this.spinning = false;
        });
      deliveryRecordMaterials({ id })
        .then((data) => {
          this.materialItems = data;
        })
        .finally(() => {
          this.materialLoading = false;
        });
    },
  },
  mounted() {
    this.initData();
  },
};
</script>
